import { createReducer, on } from '@ngrx/store';
import { ROWS_PER_PAGE } from '@shared/components';
import { usersActions } from '../actions/users.actions';
import { GetUsersValue, User, UserLookup } from '../models';

export interface UsersState {
    loaded: boolean | null;
    loading: boolean;
    users: User[];
    // The last list request, replayed to refresh the list after a delete.
    query: GetUsersValue;
    page: number;
    total: number;
    lookupLoaded: boolean | null;
    lookup: UserLookup[];
}

export const initialState: UsersState = {
    loaded: null,
    loading: false,
    users: [],
    query: { page: 1, limit: ROWS_PER_PAGE[0] },
    page: 1,
    total: 0,
    lookupLoaded: null,
    lookup: [],
};

export const usersReducer = createReducer(
    initialState,
    on(usersActions.getUsers, (state, { value }): UsersState => ({
        ...state,
        query: value,
        loading: true,
    })),
    on(usersActions.getUsersSuccess, (state, { payload }): UsersState => ({
        ...state,
        loading: false,
        loaded: true,
        users: payload.items,
        total: payload.total,
        page: payload.page,
    })),
    on(usersActions.getUsersError, (state): UsersState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    // Lookup - a loaded one stays loaded while it refetches, so a revisited view shows its options at once; a failed one goes back to pending.
    on(usersActions.getUsersLookup, (state): UsersState => ({
        ...state,
        lookupLoaded: state.lookupLoaded || null,
    })),
    on(usersActions.getUsersLookupSuccess, (state, { payload }): UsersState => ({
        ...state,
        lookupLoaded: true,
        lookup: payload,
    })),
    on(usersActions.getUsersLookupError, (state): UsersState => ({
        ...state,
        lookupLoaded: false,
    })),
    on(usersActions.clear, (): UsersState => ({ ...initialState })),
);
